import React, { useState } from 'react';
import { IonButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonInput, IonItem, IonLabel, IonList } from '@ionic/react';

const TestFetch: React.FC = () => {
  const [result, setResult] = useState<string>('');
  const [qrValue, setQrValue] = useState<string>('test-qr-code');
  const [userId, setUserId] = useState<string>('test-user-id');
  const [userCed, setUserCed] = useState<string>('test-user-ced');
  const [eventCode, setEventCode] = useState<string>('test-event-code');

  const testFetch = async () => {
    setResult('Iniciando prueba...');
    
    try {
      // Método 1: FormData con URL original
      try {
        const formData = new FormData();
        formData.append('qr', qrValue);
        formData.append('userid', userId);
        formData.append('userced', userCed);
        formData.append('eventcode', eventCode);
        
        const url1 = 'https://esimposio.com/miesimposio/app_login/asistencia/';
        setResult(prev => prev + '\nIntento 1: Enviando a ' + url1 + ' con FormData');
        
        const response1 = await fetch(url1, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
          },
        });
        
        setResult(prev => prev + '\nRespuesta 1: ' + response1.status + ' ' + response1.statusText);
        
        if (response1.ok) {
          const data1 = await response1.json();
          setResult(prev => prev + '\nDatos 1: ' + JSON.stringify(data1));
        }
      } catch (error1) {
        setResult(prev => prev + '\nError 1: ' + JSON.stringify(error1));
      }
      
      // Método 2: JSON con URL alternativa
      try {
        const jsonData = {
          qr: qrValue,
          userid: userId,
          userced: userCed,
          eventcode: eventCode
        };
        
        const url2 = 'https://esimposio.com/asistencia.php';
        setResult(prev => prev + '\nIntento 2: Enviando a ' + url2 + ' con JSON');
        
        const response2 = await fetch(url2, {
          method: 'POST',
          body: JSON.stringify(jsonData),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        });
        
        setResult(prev => prev + '\nRespuesta 2: ' + response2.status + ' ' + response2.statusText);
        
        if (response2.ok) {
          const data2 = await response2.json();
          setResult(prev => prev + '\nDatos 2: ' + JSON.stringify(data2));
        }
      } catch (error2) {
        setResult(prev => prev + '\nError 2: ' + JSON.stringify(error2));
      }
      
      // Método 3: FormData con URL alternativa
      try {
        const formData3 = new FormData();
        formData3.append('qr', qrValue);
        formData3.append('userid', userId);
        formData3.append('userced', userCed);
        formData3.append('eventcode', eventCode);
        
        const url3 = 'https://esimposio.com/asistencia.php';
        setResult(prev => prev + '\nIntento 3: Enviando a ' + url3 + ' con FormData');
        
        const response3 = await fetch(url3, {
          method: 'POST',
          body: formData3,
        });
        
        setResult(prev => prev + '\nRespuesta 3: ' + response3.status + ' ' + response3.statusText);
        
        if (response3.ok) {
          const data3 = await response3.json();
          setResult(prev => prev + '\nDatos 3: ' + JSON.stringify(data3));
        }
      } catch (error3) {
        setResult(prev => prev + '\nError 3: ' + JSON.stringify(error3));
      }
      
      // Método 4: XMLHttpRequest con URL original
      try {
        const url4 = 'https://esimposio.com/miesimposio/app_login/asistencia/';
        setResult(prev => prev + '\nIntento 4: Enviando a ' + url4 + ' con XMLHttpRequest');
        
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url4, true);
        xhr.setRequestHeader('Accept', 'application/json');
        
        const formData4 = new FormData();
        formData4.append('qr', qrValue);
        formData4.append('userid', userId);
        formData4.append('userced', userCed);
        formData4.append('eventcode', eventCode);
        
        const xhrPromise = new Promise<string>((resolve, reject) => {
          xhr.onload = function() {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve(xhr.responseText);
            } else {
              reject(new Error('XHR Error: ' + xhr.status + ' ' + xhr.statusText));
            }
          };
          
          xhr.onerror = function() {
            reject(new Error('Network error'));
          };
        });
        
        xhr.send(formData4);
        
        const xhrResponse = await xhrPromise;
        setResult(prev => prev + '\nRespuesta 4: ' + xhrResponse);
      } catch (error4) {
        setResult(prev => prev + '\nError 4: ' + error4);
      }
      
    } catch (error) {
      setResult(prev => prev + '\nError general: ' + JSON.stringify(error));
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Test Fetch</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Prueba de Fetch</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <IonList>
              <IonItem>
                <IonLabel position="stacked">QR Value</IonLabel>
                <IonInput value={qrValue} onIonChange={e => setQrValue(e.detail.value!)} />
              </IonItem>
              <IonItem>
                <IonLabel position="stacked">User ID</IonLabel>
                <IonInput value={userId} onIonChange={e => setUserId(e.detail.value!)} />
              </IonItem>
              <IonItem>
                <IonLabel position="stacked">User Ced</IonLabel>
                <IonInput value={userCed} onIonChange={e => setUserCed(e.detail.value!)} />
              </IonItem>
              <IonItem>
                <IonLabel position="stacked">Event Code</IonLabel>
                <IonInput value={eventCode} onIonChange={e => setEventCode(e.detail.value!)} />
              </IonItem>
            </IonList>
            <IonButton expand="block" onClick={testFetch}>Probar Fetch</IonButton>
          </IonCardContent>
        </IonCard>
        
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Resultado</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {result}
            </pre>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default TestFetch;
